// src/tabs/MenagesOpsTab.jsx — Aujourd'hui · Les ménages (ADMIN).
//
// ⚠️ LA BASCULE « PILOTAGE / CONTRÔLE » A ÉTÉ RETIRÉE (arbitrage Dimitri
// 2026-08-27). Elle venait de l'écran orchestrateur, où le contrôle vivait
// dedans ; chez l'ADMIN, Contrôle est un sous-onglet à part entière
// d'Aujourd'hui (JourControleCtrl, lot 3) — la bascule faisait DOUBLON et
// créait deux chemins vers la même chose. Cet onglet ne montre que le
// PILOTAGE. L'écran de l'ORCHESTRATEUR n'est pas concerné : il monte
// MenageSuiviView directement, sa bascule à lui vit chez lui.
//
// Ce qui vivait dans l'ancienne vue Contrôle et où c'est parti :
//   · photos / checklists validées des 7 jours → Aujourd'hui · Contrôle ;
//   · l'éditeur de checklist admin (ADR-207/208, « ✏️ Remplir / Corriger »)
//     → toujours atteignable par la fiche résa (AdminChecklistEditor).
//
// ANTI DOUBLE-DRAIN PHOTO (piège documenté ADR-207/208) : ce composant ne
// monte AUCUN useMenagePhotoUploadQueue — MenageSuiviView porte le drain de
// l'orchestrateur mais sa garde 5 le ferme au rôle admin.

import MenageSuiviView from "../views/MenageSuiviView"
import ControleStatsSection from "./ControleStatsSection"

export default function MenagesOpsTab({ cfg, currentUser, onNavigate, stockCentral, onControler = null }) {
  return (
    <div>
      <MenageSuiviView cfg={cfg} currentUser={currentUser}
        onNavigate={onNavigate} stockCentral={stockCentral}
        onControler={onControler} />

      {/* LOT STATS du contrôle — section repliée « Contrôle » en bas de
          l'onglet (admin seul). Fermée par défaut : elle ne charge RIEN avant
          d'être ouverte (motif SectionHistorique). */}
      <div style={{ padding: '0 16px 60px', maxWidth: 900, margin: '0 auto' }}>
        <ControleStatsSection cfg={cfg} />
      </div>
    </div>
  )
}
